export class History{
    constructor(){
        this.historyContainer = document.querySelector('.history-container');
        this.historyItems = document.querySelectorAll('.history-container > div');
    }
    init(){
        const that = this;
        if(typeof(this.historyContainer) != 'undefined' && this.historyContainer != null){
            this.adjustOrder();
            window.addEventListener('resize', function(event) {
                that.adjustOrder();
            }, true);
        }
    }
    adjustOrder(){
        if(window.innerWidth >= 1024){
            //Move even items to the end
            if(!this.historyContainer.classList.contains('desktop-order')){
                this.historyItems.forEach((historyItem)=>{
                    const order = parseInt(historyItem.getAttribute('data-order'));
                    if(order % 2 == 0){
                        this.historyContainer.appendChild(historyItem);
                    }
                });
                this.historyContainer.classList.add('desktop-order');
                this.historyContainer.classList.remove('mobile-order');
            }
        }else{
            //Reset the order to default
            if(!this.historyContainer.classList.contains('mobile-order')){
                this.historyItems.forEach((historyItem)=>{
                    const order = parseInt(historyItem.getAttribute('data-order'));
                    const referenceEl = document.querySelector('.history-container > div[data-order="'+ (order-1) +'"]');
                    if(order % 2 == 0){
                        this.insertAfter(referenceEl, historyItem);
                    }
                });
                this.historyContainer.classList.remove('desktop-order');
                this.historyContainer.classList.add('mobile-order');
            }
        }
    }
    insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
}
